function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  id: "Layer1",
  cx: 28,
  cy: 25,
  rx: 28,
  ry: 29,
  fill: "#dfdee1"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Layer2",
  cx: 28,
  cy: 24,
  r: 24,
  fill: "#fff"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "4em",
  height: "5em",
  viewBox: "0 0 56 58"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/Dot.9fceaaaa.svg";
export { SvgComponent as ReactComponent };